var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container addCapacity" },
    [
      _c(
        "div",
        { staticClass: "searchBox_top" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.saveDetail()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("common.saveDraft")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.submitDetail()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("common.release")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.historyBack } },
            [_vm._v(_vm._s(_vm.$t("common.close")))]
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "capacityDetail",
          attrs: {
            model: _vm.capacityDetail,
            "label-width": "150px",
            rules: _vm.capacityDetailRules,
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("supplierManage.Category1"),
                        prop: "category1",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "" },
                          on: {
                            change: function ($event) {
                              return _vm.changeCategory1()
                            },
                          },
                          model: {
                            value: _vm.capacityDetail.category1,
                            callback: function ($$v) {
                              _vm.$set(_vm.capacityDetail, "category1", $$v)
                            },
                            expression: "capacityDetail.category1",
                          },
                        },
                        _vm._l(_vm.categoryList1, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.name,
                              value: item.tmCategoryId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("supplierManage.Category2"),
                        prop: "category2",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.capacityDetail.category2,
                            callback: function ($$v) {
                              _vm.$set(_vm.capacityDetail, "category2", $$v)
                            },
                            expression: "capacityDetail.category2",
                          },
                        },
                        _vm._l(_vm.categoryList2, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.name,
                              value: item.tmCategoryId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.growthRateY1Show,
                      expression: "growthRateY1Show",
                    },
                  ],
                  attrs: { span: 4 },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "growthRateYTitle",
                      attrs: {
                        label: _vm.growthRateY1Title,
                        prop: "growthRateY1",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          maxLength: "10",
                          oninput: "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                        },
                        model: {
                          value: _vm.capacityDetail.growthRateY1,
                          callback: function ($$v) {
                            _vm.$set(_vm.capacityDetail, "growthRateY1", $$v)
                          },
                          expression: "capacityDetail.growthRateY1",
                        },
                      }),
                      _vm._v("% "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.growthRateY2Show,
                      expression: "growthRateY2Show",
                    },
                  ],
                  attrs: { offset: 1, span: 4 },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "growthRateYTitle",
                      attrs: {
                        label: _vm.growthRateY2Title,
                        prop: "growthRateY2",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          maxLength: "10",
                          oninput: "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                        },
                        model: {
                          value: _vm.capacityDetail.growthRateY2,
                          callback: function ($$v) {
                            _vm.$set(_vm.capacityDetail, "growthRateY2", $$v)
                          },
                          expression: "capacityDetail.growthRateY2",
                        },
                      }),
                      _vm._v("% "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.growthRateY3Show,
                      expression: "growthRateY3Show",
                    },
                  ],
                  attrs: { offset: 1, span: 4 },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "growthRateYTitle",
                      attrs: {
                        label: _vm.growthRateY3Title,
                        prop: "growthRateY3",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          maxLength: "10",
                          oninput: "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                        },
                        model: {
                          value: _vm.capacityDetail.growthRateY3,
                          callback: function ($$v) {
                            _vm.$set(_vm.capacityDetail, "growthRateY3", $$v)
                          },
                          expression: "capacityDetail.growthRateY3",
                        },
                      }),
                      _vm._v("% "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.growthRateY4Show,
                      expression: "growthRateY4Show",
                    },
                  ],
                  attrs: { offset: 1, span: 4 },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "growthRateYTitle",
                      attrs: {
                        label: _vm.growthRateY4Title,
                        prop: "growthRateY4",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          maxLength: "10",
                          oninput: "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                        },
                        model: {
                          value: _vm.capacityDetail.growthRateY4,
                          callback: function ($$v) {
                            _vm.$set(_vm.capacityDetail, "growthRateY4", $$v)
                          },
                          expression: "capacityDetail.growthRateY4",
                        },
                      }),
                      _vm._v("% "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.growthRateY5Show,
                      expression: "growthRateY5Show",
                    },
                  ],
                  attrs: { offset: 1, span: 4 },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "growthRateYTitle",
                      attrs: {
                        label: _vm.growthRateY5Title,
                        prop: "growthRateY5",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          maxLength: "10",
                          oninput: "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                        },
                        model: {
                          value: _vm.capacityDetail.growthRateY5,
                          callback: function ($$v) {
                            _vm.$set(_vm.capacityDetail, "growthRateY5", $$v)
                          },
                          expression: "capacityDetail.growthRateY5",
                        },
                      }),
                      _vm._v("% "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-row"),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("common.remarks"),
                        prop: "remarks",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "handle-input",
                        attrs: {
                          type: "textarea",
                          maxlength: "300",
                          autosize: "",
                        },
                        model: {
                          value: _vm.capacityDetail.remarks,
                          callback: function ($$v) {
                            _vm.$set(_vm.capacityDetail, "remarks", $$v)
                          },
                          expression: "capacityDetail.remarks",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("capacity.UploadCapacityDetails"),
                      },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          staticClass: "detailDocfileList",
                          attrs: {
                            data: _vm.detailDocfileList,
                            border: "",
                            "highlight-current-row": "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              sortable: "",
                              prop: "documentName",
                              label: _vm.$t("common.file"),
                              "min-width": "130px",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-link",
                                      {
                                        attrs: { type: "primary" },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.downloadFile(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.documentName) + " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "tmDocumentId",
                              "min-width": "130px",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-link",
                                      {
                                        attrs: { type: "primary" },
                                        nativeOn: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.deleteFile(
                                              scope.row.tmDocumentId,
                                              scope.$index,
                                              _vm.detailDocfileList
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("common.del")))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-upload",
                        {
                          ref: "uploadRef",
                          attrs: {
                            action: "upload",
                            "http-request": _vm.uploadConfirm,
                            "on-remove": _vm.detailDocfileRemove,
                            multiple: "",
                            "show-file-list": "false",
                            name: "file",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "trigger",
                                size: "small",
                                type: "primary",
                              },
                              slot: "trigger",
                            },
                            [_vm._v(_vm._s(_vm.$t("common.selectFile")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-button",
        { attrs: { type: "primary" }, on: { click: _vm.addSupplier } },
        [_vm._v(_vm._s(_vm.$t("base.supplier.addSupplier")))]
      ),
      _c(
        "el-button",
        {
          attrs: { type: "danger" },
          on: {
            click: function ($event) {
              return _vm.delSupplier()
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("common.del")))]
      ),
      _c(
        "el-form",
        {
          ref: "supplierCapacityForm",
          attrs: {
            model: _vm.supplierCapacityForm,
            rules: _vm.supplierCapacityFules,
          },
        },
        [
          _c(
            "el-table",
            {
              ref: "supplierCapacityList",
              attrs: {
                data: _vm.supplierCapacityForm.supplierCapacityList,
                border: "",
                "highlight-current-row": "",
                "max-height": "420",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "tmSupplierId",
                  type: "selection",
                  "min-width": "55",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "supplierCode",
                  label: _vm.$t("spm.invitationCode"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "supplierName",
                  label: _vm.$t("capacity.supplierNameShort"),
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelSupplierDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelSupplierDialog = $event
            },
          },
        },
        [
          _vm.SupplierNameDialogReset
            ? _c("SelSupplier", {
                ref: "supplierSelRef",
                attrs: { multipleSelectionFlag: true },
                on: { subCallMethod: _vm.selectSupplierMethod },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }